import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { graphQLClient, graphQLClientGET } from '~src/api/graphql'
import { GET_AVAILABLESTORES } from '~src/api/language'

export const useSetLanguage = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('')

  const { data: dataLanguage, isLoading: isLoadingDataLanguage } = useQuery({
    queryKey: ['getLanguage'],
    queryFn: async () => {
      const data = (await graphQLClientGET.request(GET_AVAILABLESTORES)) as {
        availableStores: TLanguage[]
      }
      return data?.availableStores
    },
    cacheTime: Infinity,
  })

  const handleSelectedLanguage = (language: string) => {
    graphQLClient.setHeaders({
      store: language,
    })
    localStorage.setItem('language', language)
    setSelectedLanguage(language)
    window.location.reload()
  }

  useEffect(() => {
    const getLanguage = localStorage.getItem('language')
    if (!!getLanguage) {
      if (getLanguage === 'vi') {
        setSelectedLanguage('vi')
      } else {
        setSelectedLanguage('en')
      }
    } else {
      setSelectedLanguage('vi')
    }
  }, [])

  return { dataLanguage, isLoadingDataLanguage, selectedLanguage, handleSelectedLanguage }
}
